import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { useAppSelector } from '@/app/hooks';
import Rail from './Rail';
import TabBar from './TabBar';
import Splash from './Splash';

/**
 * App shell: landscape rail (lg) · content · phone tab bar (<lg).
 * Pages render their own header (StoreHeader / PageShell) and own their scroll container.
 * Redirects to shop-select when no shop is selected (except on that page itself).
 */
const Layout: React.FC = () => {
    const { selectedShop, isInitialized } = useAppSelector((state) => state.auth);
    const isShopSelectPage = window.location.pathname === '/shop-select';

    if (!isInitialized) return <Splash />;

    if (!selectedShop && !isShopSelectPage) {
        return <Navigate to="/shop-select" replace />;
    }

    return (
        <div className="flex h-dvh bg-surface-page">
            {selectedShop && <Rail />}
            <main className={`flex min-w-0 flex-1 flex-col overflow-hidden ${selectedShop ? 'pb-20 lg:pb-0' : ''}`}>
                <Outlet />
            </main>
            {selectedShop && <TabBar />}
        </div>
    );
};

export default Layout;
